import { trackClientEvent } from '../../../../../trackClientEvent';
import { timingPairStringify, } from '@faire/web/common/timings/TimingMarker';
export const eventKey = 'signup-time_from_email_to_button-timing';
/**
 * Time taken between email input and email submit on Sign Up modal
 */
export function trackSignupTimeFromEmailToButtonTiming(timingParameterToken) {
    var _a;
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            timingParameterToken: (_a = timingPairStringify(timingParameterToken)) !== null && _a !== void 0 ? _a : '',
        },
    });
}
